import { useEffect, useState } from "react";
import useFirestore from "./useFirestore";
import useAccount from "../authorization/useAccount";

function useHeader(){
    const uid = sessionStorage.getItem("uid");
    const {getCommonUser} = useAccount(uid);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [toggle, setToggle] = useState("false");
    const [name, setName] = useState("");
    const [isBurgerClicked, setIsBurgerClicked] = useState(false);
    const updateScroll = () => {
        setScrollPosition(window.scrollY || document.documentElement.scrollTop);
    };

    useEffect(() => {
        window.addEventListener("scroll", updateScroll);
        return () => {
        window.removeEventListener("scroll", updateScroll);
        };
    }, []);

    useEffect(() => {
        getUserName();
    }, [uid])

        // scroll 위치가 100이하라면 투명한 배경색을 지정하고, 아니면 흰색을 지정한다.
    useEffect(() => {
        if (scrollPosition < 30) {
            setToggle("false")
        } else {
            setToggle("true");
        }
    }, [scrollPosition]);

    const getUserName = async() => {
        const account = await getCommonUser();
        if(account){
            setName(account.name);
        }
    }

    const onBurgerClickHandler = () => {
        setIsBurgerClicked(true);
    }

    const onCloseClickHandler = () => {
        setIsBurgerClicked(false);
    }

    return {scrollPosition, toggle, name, isBurgerClicked, onBurgerClickHandler, onCloseClickHandler};
}

export default useHeader;